export default "__VITE_ASSET__BQdgWUQU__"